import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const devErr = process.env.NODE_ENV !== 'production' ? console.error.bind(console) : () => {};

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate('/');
      return;
    }

    (async () => {
      try {
        const { data } = await axios.get(
          `${API}/auth/session?session_id=${sessionId}`,
          { withCredentials: true }
        );
        // Save token to localStorage as fallback (handles production proxy environments).
        // See security note in AuthContext.js for rationale.
        if (data.token) localStorage.setItem('hl_token', data.token);
        setAuthUser(data);
        navigate(data.role === 'admin' ? '/admin' : '/');
      } catch (e) {
        devErr('[AuthCallback] session exchange failed', e);
        navigate('/auth');
      }
    })();
  }, [navigate, setAuthUser]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#D4AF37] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-playfair text-xl text-[#0A0A0A] mb-1">Authenticating</p>
        <p className="text-xs uppercase tracking-[0.2em] text-[#D4AF37]">Please wait...</p>
      </div>
    </div>
  );
}
